import { setSpecificMessage, value } from "valibot";
setSpecificMessage(
  value,
  (issue) => `Valeur invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);